<template>
    <div class="wrapper">
        <!-- Sidebar -->
        <SideBar :user="user" @links-updated="linksUpdated" />

        <!-- Page Content -->
        <div id="content">
            <!-- We'll fill this with dummy content -->
            <b-navbar toggleable="md" type="light" variant="orange">
                <!-- <b-button id="sidebarCollapse" variant="light" size="sm" @click="expandSidebar = !expandSidebar"><i class="material-icons">menu</i></b-button> -->
                <b-navbar-brand href="#"><span class="h3" style="font-weight:300;">{{ title }}</span></b-navbar-brand>

                <b-collapse id="nav_collapse" is-nav>
                    <!-- Right aligned nav items -->
                    <!-- <b-navbar-nav class="ml-auto">

						<b-nav-item href="#" @click="logout">Log out</b-nav-item>
					</b-navbar-nav> -->
                    <!-- <b-nav-item v-for="link in links" :key="link.name" :to="link.path">
						{{link.name}}
					</b-nav-item> -->



                    <b-nav-item-dropdown class="ml-auto" style="list-style:none;">
                        <!-- Using button-content slot -->
                        <template slot="button-content">
                            {{ user ? `${user.email} (${user.customerName})` : '' }}
                        </template>
                        <!-- <b-dropdown-item href="#" disabled="disabled">Profile</b-dropdown-item> -->
                        <b-dropdown-item href="#" @click="logout">Log out</b-dropdown-item>
                        <b-dropdown-item to="/settings">Account Settings</b-dropdown-item>
                        <!-- <b-nav-item href="#" @click="logout">Log out</b-nav-item> -->
                    </b-nav-item-dropdown>
                </b-collapse>

                <b-navbar-toggle target="nav_collapse" />
            </b-navbar>

            <div class="main-content">
                <nuxt ref="page" />
            </div>
        </div>
    </div>
</template>

<script>
import SideBar from '~/components/SideBar.vue';
import { mapGetters, mapState } from 'vuex';

export default {
	components: {
		SideBar
	},
	data: function() {
		return {
			title: '',
			links: [],
			error: null
		};
	},
	head() {
		let self = this;
		if (process.browser) {
			this.title = document.title;
		}
		return {
			changed({title}) {
				self.title = title;
			}
		};
	},
	computed: {
		...mapGetters({
			isLoggedIn: 'user/isAuthenticated',
		}),
		...mapState({
			user: state => state.user.user,
			authError: state => state.user.authError,
		}),
	},
	methods: {
		logout() {
			this.$store.dispatch('user/logout');
		},
		linksUpdated(links) {
			this.links = links;
		}
	},
};
</script>

<style scoped>
.wrapper {
    display: flex;
	align-items: stretch;
	width: 100%;
}

#content {
    width: 100%;
    min-height: 100vh;
    transition: all 0.3s;
}

nav {
	background-color: rgba(255, 255, 255, 0.96);
	border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

/* .sidebar {
	overflow: auto;
	height: 100%;
	display: block;
}

.main-panel {
	background-color: rgba(203, 203, 210, 0.15);
	min-height: 100vh;
} */

.main-content {
	padding: 30px 15px;
	/* height: 93vh; */
	height: calc( 100vh - 65px );
	overflow: auto;
}

/* .container-fluid {
	padding-left: 0px;
	padding-right: 0px;
	height: 100%;
} */

</style>

<style>
html
{
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 16px;
  word-spacing: 1px;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
}
*, *:before, *:after
{
  box-sizing: border-box;
  margin: 0;
}
</style>
